import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download_staging/6a61e16a99f1da00143be93f_1786979501641_3c686fb9/pospro/src/app/sign-up-login-screen/components/AuthScreen.tsx");
